'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultDomainOnly = exports.DefaultSurveyStep = exports.JoinHubspotUser = exports.ExistingAccount = exports.JoinHubspotAccount = exports.FramedGettingStarted = exports.DefaultGettingStarted = exports.ExistingUserShort = exports.WordPressExistingUser = exports.DefaultExistingUser = exports.DetectAuthEmbeddedContent = exports.DetectAuthCheckout = exports.DetectAuthHubless = exports.DetectAuthJoinHubspot = exports.DefaultDetectAuth = undefined;

var _RouterActions = require('../../core/actions/RouterActions');

var _HublessAuth = require('../../core/auth/HublessAuth');

var _HublessAuth2 = _interopRequireDefault(_HublessAuth);

var _appStepRoutes = require('../../core/constants/appStepRoutes');

var _appStepRoutes2 = _interopRequireDefault(_appStepRoutes);

var _Auth = require('../../core/utils/Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _DetectAuthStep = require('./steps/DetectAuthStep');

var _DetectAuthStep2 = _interopRequireDefault(_DetectAuthStep);

var _DomainOnlyStep = require('./steps/DomainOnlyStep');

var _DomainOnlyStep2 = _interopRequireDefault(_DomainOnlyStep);

var _ExistingAccount = require('./steps/ExistingAccount');

var _ExistingAccount2 = _interopRequireDefault(_ExistingAccount);

var _ExistingUserStep = require('./steps/ExistingUserStep');

var _ExistingUserStep2 = _interopRequireDefault(_ExistingUserStep);

var _GettingStartedStep = require('./steps/GettingStartedStep');

var _GettingStartedStep2 = _interopRequireDefault(_GettingStartedStep);

var _JoinHubspotUser = require('./steps/JoinHubspotUser');

var _JoinHubspotUser2 = _interopRequireDefault(_JoinHubspotUser);

var _JoinHubspotAccount = require('./steps/JoinHubspotAccount');

var _JoinHubspotAccount2 = _interopRequireDefault(_JoinHubspotAccount);

var _SurveyStep = require('./steps/SurveyStep');

var _SurveyStep2 = _interopRequireDefault(_SurveyStep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultDetectAuth = exports.DefaultDetectAuth = (0, _DetectAuthStep2.default)();
var DetectAuthJoinHubspot = exports.DetectAuthJoinHubspot = (0, _DetectAuthStep2.default)(_appStepRoutes.JOIN_HUBSPOT);
var DetectAuthHubless = exports.DetectAuthHubless = (0, _DetectAuthStep2.default)(_appStepRoutes.JOIN_HUBSPOT_ACCOUNT, _HublessAuth2.default, undefined, _appStepRoutes2.default.EXISTING_USER);
var DetectAuthCheckout = exports.DetectAuthCheckout = (0, _DetectAuthStep2.default)(_appStepRoutes.CREATE_CHECKOUT_USER);
var DetectAuthEmbeddedContent = exports.DetectAuthEmbeddedContent = (0, _DetectAuthStep2.default)(_appStepRoutes.JOIN_HUBSPOT, _Auth2.default, _appStepRoutes.EXISTING_ACCOUNTS_MINIMAL);
var DefaultExistingUser = exports.DefaultExistingUser = (0, _ExistingUserStep2.default)();
var WordPressExistingUser = exports.WordPressExistingUser = (0, _ExistingUserStep2.default)(_appStepRoutes.JOIN_HUBSPOT_ACCOUNT, true);
var ExistingUserShort = exports.ExistingUserShort = (0, _ExistingUserStep2.default)(_appStepRoutes.JOIN_HUBSPOT);
var DefaultGettingStarted = exports.DefaultGettingStarted = (0, _GettingStartedStep2.default)();
var FramedGettingStarted = exports.FramedGettingStarted = (0, _GettingStartedStep2.default)(true);
var JoinHubspotAccount = exports.JoinHubspotAccount = (0, _JoinHubspotAccount2.default)();
var ExistingAccount = exports.ExistingAccount = (0, _ExistingAccount2.default)(function () {
  return (0, _RouterActions.goToStep)(_appStepRoutes.DOMAIN);
});

exports.JoinHubspotUser = _JoinHubspotUser2.default;
exports.DefaultSurveyStep = _SurveyStep2.default;
exports.DefaultDomainOnly = _DomainOnlyStep2.default;